import axiosInstance from "../config/axiosInstance";

export const getHomeBanners = async (languageCode = 'vi') => {
  try {
    const response = await axiosInstance.get(
      `/home-banners/${languageCode}`
    );
    const data = response.data;
    if (data && data.success && Array.isArray(data.data)) {
      return data.data;
    } else if (Array.isArray(data)) {
      return data;
    }
    return [];
  } catch (error) {
    console.error(`[getHomeBanners] Lỗi khi lấy Home Banners (lang=${languageCode}):`, error);
    return [];
  }
};
